<template>
	<div id="basket" class="basket" >

		<div class="wrapper">

			<h1>PREGLED KORPE</h1>
			<br>
			<br v-if="cart.length == 0">
			<h2 v-if="cart.length == 0"> KORPA JE PRAZNA </h2>
			<br v-if="cart.length == 0">
			<div class="korpa">

				<div class="description">
					<!-- <div class="opis">
						<p> <strong>{{c.ime}}</strong></p>
						<br>

					</div> -->

				<div class="cena" v-if="cart.length > 0">
						<table>
							<tr><th>R.br.</th> <th>Opis</th><th>Kom</th><th> Jed. cena</th><th>Ukupno</th><th>&nbsp</th> </tr>
							<tr v-for="(c,index) in cart">
								<td>{{index +1}}</td>
								<td>{{c.ime}} - {{c.pakovanje}}</td>
								<td>
								<button type="button" @click="smanji(c)">-</button>
								{{c.kolicina}}
								<button type="button" name="button" title="Increase" @click="povecaj(c)">+</button>
							</td>
								<!-- <td></td> -->
								<td>{{(c.cena * kurs).toFixed(2)}} RSD</i></td>
								<td>{{(c.cena * c.kolicina * kurs).toFixed(2)}} RSD</i></td>
								<td><img  @click="remove(index)"  src="static/imgs/del.png" title="Ukloni proizvod" alt=""></td>
							</tr>
						</table>
						<br>
						<br>
						<div class="totals">
							<table>
								<!-- <tr>
									<td><strong>Svega</strong> </td>
									<td><span>{{getsubtotal}} RSD</span></td>
								</tr> -->
								<tr>
									<!-- <td><strong>Poštarina</strong></td>
									<td><span>{{getshipping}},00 RSD</span></td> -->
								</tr>
								<tr>
								<td><strong>UKUPNO</strong></td>
								<td><span>{{gettotal}},00 RSD</span></td>
								</tr>
							</table>
						</div>


					</div>
					<div class="cenamob" v-if="cart.length > 0">
							<table>
								<tr> <th> Opis</th><th>Kom</th><th>Ukupno</th> </tr>
								<tr v-for="(c,index) in cart">
									<td style="position:relative; padding-left:20px"><i @click="remove(index)" class="far fa-times-circle" title="Ukloni proizvod"></i> {{c.ime}} - {{c.pakovanje}}</td>
									<td style="text-align:center">
									<button type="button" @click="smanji(c)">-</button>
									{{c.kolicina}}
									<button type="button" name="button" title="Increase" @click="povecaj(c)">+</button>
								</td>
									<!-- <td></td> -->
									<!-- <td>{{c.cena }}</i></td> -->
									<td>{{(c.cena * c.kolicina * kurs).toFixed(2)}}</td>
									<!-- <td style="width:20px"><img  @click="remove(index)"  src="static/imgs/del.png" title="Ukloni proizvod" alt=""></td> -->
								</tr>
							</table>
							<br>
							<br>
							<div class="totals">
								<table>
									<!-- <tr>
										<td><strong>Svega</strong> </td>
										<td><span>{{getsubtotal}} RSD</span></td>
									</tr> -->
									<tr>
										<!-- <td><strong>Poštarina</strong></td>
										<td><span>{{getshipping}},00 RSD</span></td> -->
									</tr>
									<tr>
									<td><strong>UKUPNO</strong></td>
									<td><span>{{gettotal}},00 RSD</span></td>
									</tr>
								</table>
							</div>


						</div>

				</div>
			</div>
			<div class="porudzbenica">
				<br>
				<div class="poklon" >
					<div v-if="cart.length > 0 "  class="obavestenje">
						<!-- <span>*Navedeni uslovi i cene isporuke važe samo za teritoriju Republike Srbije.</span> -->
						<br>
						<span> Molimo Vas <router-link to="/kontakt" style="color:var(--zelena)">kontaktirajte nas</router-link> za više informacija</span>

					</div>


				<a href="javascript:history.go(-1)"><button class="back"  type="button" name="button" title="Nazad na stranu sa proizvodima" > < NASTAVI KUPOVINU</button></a>
					<div v-if="cart.length > 0 " class="terms">
						<p>Klikom na "PORUČI" slažete se sa <span @click="uslovi($event)"> Korisničkim uslovima </span> i potvrđujete da ste pročitali <span @click="prava($event)"> Pravila privatnosti </span>.</P>
					</div>
					<button  v-if="cart.length > 0 " class="poruci" type="button" id="por" name="button" @click="por()" title="Klikni i poruči">PORUČI ></button>

				</div>

			<div  v-if="placanje && cart.length > 0 "  class="kontakt">
					<p><strong>ADRESA ISPORUKE</strong></p>
					<br>
					<p>* Obavezna polja</p>
					<form class="place">
						<div class="form-row">
							<input  class="inp" id="Email" v-model="user.email" type="email" required>
							<label class="placehold" for="E-mail">* E-mail</label>
						</div>
							<div class="form-row">
								<input  class="inp" id="Ime" v-model="user.ime" type="text" required>
								<label class="placehold" for="Ime">* ime</label>
							</div>
							<div class="form-row">
								<input  class="inp" id="Prezime" v-model="user.prezime" type="text" required>
								<label class="placehold" for="Prezime">* Prezime</label>
							</div>
							<div class="form-row">
								<input  class="inp" id="Adresa" v-model="user.adresa" type="text" required>
								<label class="placehold" for="Adresa">* Adresa</label>
							</div>
							<div class="form-row">
								<input  class="inp" id="Grad" v-model="user.grad" type="text" required>
								<label class="placehold" for="Grad">* Grad</label>
							</div>
							<div class="form-row">
								<input  class="inp" id="PTT Broj" v-model="user.pttbroj" type="text" required>
								<label class="placehold" for="PTT Broj">* PTT Broj</label>
							</div>
							<div class="form-row">
								<input  class="inp" id="Telefon" v-model="user.telefon" type="phone" required>
								<label class="placehold" for="Telefon">* Telefon</label>
							</div>


					</form>
					<div class="errors">
						{{errors}}
					</div>

					<button   @click="orderpro()" class="poruci" type="button" name="button" title="Click and order">ZAVRŠI KUPOVINU ></button>
					<!-- <button v-if="!agree" type="button" @click="step2()" name="button">Sledeći korak></button> -->
				</div>



				<!-- <div v-if="agree" class="placanje">

					<button  v-if="final ==true" @click="orderpro()" class="poruci" type="button" name="button" title="Click and order">ZAVRŠI KUPOVINU ></button>




				</div> -->


			</div>
		</div>

		<!-- <div class="prazan" v-if="getsubtotal <1">
			<br>
			<br>
		</div> -->

		<uslovi v-if="" v-show="showuslovi"></uslovi>
		<prava v-if="" v-show="showprava"></prava>
	</div>

</template>
<script>
// import axios from "axios"
import uslovi from '@/components/uslovi'
import prava from '@/components/prava'
import {mapGetters, mapActions, mapMutations} from 'vuex';

	export default {
		components: {
		prava,
		uslovi
		},
    data() {
      	return {
						del:false,
						// shipp:350,
						errors:"",
					  agree:false,
						final:false,
						placanje:false,
						kol:"",
						additional: '',
						opet:false,
						interval:null,
						user:{
							ime:null,
							prezime:null,
							email:null,
							adresa:null,
							grad:null,
							pttbroj:null,
							telefon:null,
						},
						price:25
      		}
    	},
			computed:{
			  ...mapGetters([
						'kurs',
			      'cart',
						'gettotal',
						'getsubtotal',
						'poruceno',
						// 'getsid',
						'showterms',
						'showpolicy',
						'showprava',
						'showuslovi'

			  ]),
				...mapMutations([
			    'clearcart'


			  ]),


			},
			// watch:{
			//
			// 	shipp:function(){
			// 		this.setshipping(this.shipp)
			// 		this.settotal(this.cart)
			// 	},

    	methods: {
				remove(i){
					this.removepro(i)
					this.settotal(this.cart)
						// if(this.getsubtotal = 0){
						// 	this.placanje = false
						// }

				},
				por(){
					document.getElementById('por').scrollIntoView()
							this.placanje = true
				},
				uslovi(e){
					this.setuslovi(!this.showuslovi);
						e.stopPropagation()
				},
				prava(e){
					this.setprava(!this.showprava);
						e.stopPropagation()
				},
				term(e){
					this.setterms(!this.showterms);
						e.stopPropagation()
				},
				policy(e){
					this.setpolicy(!this.showpolicy);
						e.stopPropagation()
				},
				povecaj(pro){
					if(pro.kolicina > 500){
						return
					}else {
					this.setkolplus(pro)
					console.log(this.cart);
					this.settotal(this.cart)
				}

				},
				smanji(pro){
					if(pro.kolicina < 2){
						return
					}else {

						this.setkolminus(pro)
						this.settotal(this.cart)
						// if(this.getsubtotal < 5000){
						// 	this.shipp = ""
						// }
					}

				},
				validemail(email) {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(email);
				},
				validphone(phone){
					var ph = /\+?[0-9 ]{6,18}/;
					return ph.test(phone);
				},
				testemail(){
					if(this.validemail(this.user.email)){
						this.agree = true
							}else{
								alert('pogrešan e-mail');
								return;
						}
				},
				go(){
						this.$router.push("/proizvodi");

				},

		async orderpro(){
				this.testemail()
				if(this.agree){

				}else {
					return
				}
				const areAllFieldsFilledIn = Object
					.keys(this.user)
					.every(key => !!this.user[key])
				if (!areAllFieldsFilledIn) {
					alert('Molimo Vas da popunite sva obavezna polja *')
					return
				}
				try {
					var now = new Date().toDateString();
					 var order =[
						this.cart,
						this.user,
						this.shipp,
						now,
						this.kurs
					]
					var ord = JSON.stringify(order);
						 await this.orders(ord)
				} catch (e) {

				} finally {
					alert('Zahvaljujemo Vam se na poverenju, vaša porudžbenica je primljena. Uskoro će te dobiti potvrdu putem E-mail-a')
					console.log(this.poruceno);
					 await (this.poruceno)
					 if (this.poruceno){
						 this.$router.push("/")
							this.clearcart()

					}



				}




				},

				scrollBehavior() {
        return {x: 0, y: -150}
    },
				poruci(){
					if(this.cart.length == 0){
						alert('Niste odabrali proizvod za kupovinu')
					}
					alert('Popuni podatke...')
				},

				...mapMutations([
					'setcart',
					'changecart',
					'removepro',
					'settotal',
					'setkolplus',
					'setkolminus',
					'setprava',
					'setuslovi'
			]),
			...mapActions([
				'getkurs',
				'orders'

			]),


    	},

    	mounted () {
				this.getkurs(1)
				document.getElementById('myheader').scrollIntoView();
			  window.scroll(0,0);
				// this.checksession(this.getsid)
				// this.getcategories()
				this.settotal(this.cart)

				// this.setshipping(null);



    	}
	}
</script>
<style scoped lang="">

</style>



// WEBPACK FOOTER //
// src/components/basket.vue